import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@tsuyosa/auth';

export function Layout({ children }: { children: React.ReactNode }) {
  const { user, logout } = useAuth();
  const navigate         = useNavigate();
  const location         = useLocation();

  async function handleLogout() {
    await logout();
    navigate('/login');
  }

  const isActive = (path: string) =>
    location.pathname === path ? 'text-[#f472b6]' : 'text-white/70 hover:text-white';

  return (
    <div className="flex min-h-screen flex-col">
      {/* Navbar */}
      <nav className="sticky top-0 z-50 border-b border-white/5 bg-[#0d0a12]/90 backdrop-blur-md">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-3">
          <Link to="/" className="text-lg font-bold text-gradient-tsuyosa">
            TSUN
          </Link>

          <div className="flex items-center gap-6 text-sm font-medium">
            <Link to="/" className={`transition-colors ${isActive('/')}`}>
              Beranda
            </Link>
            <Link to="/members" className={`transition-colors ${isActive('/members')}`}>
              Member
            </Link>
            <Link to="/discography" className={`transition-colors ${isActive('/discography')}`}>
              Discography
            </Link>
            <Link to="/cheki" className={`transition-colors ${isActive('/cheki')}`}>
              Cheki
            </Link>
            <Link to="/orders" className={`transition-colors ${isActive('/orders')}`}>
              Pesanan
            </Link>
            <Link to="/profile" className={`transition-colors ${isActive('/profile')}`}>
              Profil
            </Link>
          </div>

          <div className="flex items-center gap-3">
            {user && (
              <span className="hidden text-sm text-white/50 sm:block">
                {user.display_name ?? user.username}
              </span>
            )}
            <button
              onClick={handleLogout}
              className="rounded-md border border-white/10 px-3 py-1.5 text-sm text-white/70 transition-colors hover:border-white/30 hover:text-white"
            >
              Keluar
            </button>
          </div>
        </div>
      </nav>

      {/* Content */}
      <main className="flex-1">{children}</main>

      {/* Footer */}
      <footer className="border-t border-white/5 bg-[#0d0a12] py-6 text-center text-sm text-white/30">
        © {new Date().getFullYear()} Tsuyosa. All rights reserved.
      </footer>
    </div>
  );
}
